import React from 'react';
import { DropdownIcon } from '../../svg/DropdownIcon';
export var CustomDropdownIcon = function (props) {
    var getStyles = props.getStyles;
    return (React.createElement("div", { style: getStyles('dropdownIndicator', props) },
        React.createElement(DropdownIcon, null)));
};
